import { uniqBy } from 'lodash-es';

import { SET_BREADCRUMBS } from './mutation-types';

export default {
  [SET_BREADCRUMBS](state, breadcrumbs) {
    state.breadcrumbs = uniqBy(breadcrumbs, 'position').sort((a, b) => a.position - b.position);
  },
};
